<template>
  <b-card header="Company Rebate" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div class="row">
      <div v-if="!e_set_up_rebate" class="col-12">
        <div v-if="notEmptyObject(referral_rebate)" class="row">
          <div v-if="!notEmptyObject(referral_rebate.rebate)" class="col-12">
            <div class="row">
              <div class="col-xl-8">
                <p class="font-weight-bold pt-0 mb-3">Client Does note have a rebate</p>
              </div>
              <div class="col-xl-4">
                <button @click="edit_form()" v-if="isAdminManagerUser" class="btn orcaBtn sm_btn float-right mb-3">Setup rebate</button>
              </div>
            </div>
          </div>
          <div v-else class="col-12">
            <div class="referrals">
              <div class="referral_text">
                <div>
                  <span style="width: 130px;" class="d-inline-block font-weight-bold">Referral Start Date:</span>
                  <span>{{ return_referral_start_date }}</span>
                </div>
                <div>
                  <span style="width: 130px;" class="d-inline-block font-weight-bold">Referral End Date:</span>
                  <span>{{ return_referral_end_date }}</span>
                </div>
              </div>
              <div class="referral_cost">
                <span class="font-weight-bold b2_color d-block" style="font-size: 1.6rem;">{{ return_amount_per_payrolled_worker }}</span>
                <div class="b3_color" style="line-height: 1.2;"><span class="d-block">PER PAYROLLED</span><span class="d-block">WORKER</span></div>
              </div>
            </div>
            <button @click="cancel_rebate" v-if="isAdminManagerUser" class="btn orcaBtn sm_btn danger mb-3 float-right">cancel rebate</button>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <p class="font-weight-bold pt-0 mb-3">Client Does note have a rebate ..</p>
            <button @click="edit_form('edit_set_up_rebate')" v-if="isAdminManagerUser" class="btn orcaBtn sm_btn mb-3">Setup rebate</button>
          </div>
        </div>
      </div>
      <ValidationObserver ref="editSetUpRebateForm" slim tag="div" class="col-12" v-if="e_set_up_rebate">
        <form role="form" @submit.prevent="submit_form">
          <div class="row">
            <!-- Rebate Amount per payrolled worker -->
            <ValidationProvider rules="required|decimal" v-slot="{errors, classes}" name="Rebate Amount per payrolled worker" tag="div" class="col-12 form-group">
              <label class="form-label" for="edit_amount_per_payrolled_worker">Rebate Amount per payrolled worker</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                <input type="text" v-model="edit_rebate.amount_per_payrolled_worker" id="edit_amount_per_payrolled_worker"
                       name="edit_amount_per_payrolled_worker" class="form-input" :class="classes">
              </div>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Referral start date -->
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Referral start date" tag="div" class="col-xl-6 form-group">
              <label class="form-label" for="edit_referral_start_date">Referral start date</label>
              <datepicker v-model="edit_rebate.referral_start_date" id="edit_referral_start_date" name="edit_referral_start_date"
                          :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                          clear-button-icon="far fa-calendar-times" @input="select_rebate_start_date" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Referral end date -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Referral end date" tag="div" class="col-xl-6 form-group">
              <label class="form-label" for="edit_referral_end_date">Referral end date</label>
              <datepicker v-model="edit_rebate.referral_end_date" id="edit_referral_end_date" name="edit_referral_end_date"
                          :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                          clear-button-icon="far fa-calendar-times" @input="select_rebate_end_date" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
          <div class="row mb-3">
            <div class="col-xl-6">
              <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
            </div>
            <div class="col-xl-6">
              <button type="submit" class="btn orcaBtn sm_btn w-100">add rebate</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-card>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
export default {
  name: "company_rebate",
  components: {
    Datepicker,
  },
  props: [
      'referral_rebate',
      'isAdminManagerUser',
      'company'
  ],
  data() {
    return {
      e_set_up_rebate: false,
      edit_rebate: {},
    }
  },
  computed: {
    /**
     * Return formatted referral start date
     * If no start date then return empty string
     * @returns {*|string}
     */
    return_referral_start_date() {
      return this.referral_rebate.rebate.referral_start_date !== null
          ? this.$options.filters.formatDate(this.referral_rebate.rebate.referral_start_date)
          : "No End Date";
    },
    /**
     * Return formatted referral end date if there is one
     * If no end date then return string 'No End Date'
     * @returns {*|string}
     */
    return_referral_end_date() {
      return this.referral_rebate.rebate.referral_end_date !== null
          ? this.$options.filters.formatDate(this.referral_rebate.rebate.referral_end_date)
          : "No End Date";
    },
    /**
     * Return formatted currency value of the rebate for the company per worker
     * @returns {*}
     */
    return_amount_per_payrolled_worker() {
      return this.$options.filters.currency(this.referral_rebate.rebate.amount_per_payrolled_worker)
    }
  },
  methods: {
    /* -----------------------------------------------------------------------------------------------
     * Viewing form functions
     * -----------------------------------------------------------------------------------------------
     */
    /**
     * Delete company rebate and reload data shown on vue
     */
    cancel_rebate() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Cancel Rebate</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you want to cancel the rebate for:<br><br>' + this.company.company_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              // delete company rebate record from database
              axios.delete(this.crmApiPath + 'company/referral_rebate/' + this.referral_rebate.rebate.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$bus.$emit('company_referral::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /* -----------------------------------------------------------------------------------------------
     * Form functions
     * -----------------------------------------------------------------------------------------------
     */
    /**
     * Switch vue to show form to edit company rebate
     * OR if there is no existing rebate - enter a company rebate
     */
    edit_form() {
      // if there is no pre-existing rebate for the company
      if (this.referral_rebate.rebate.length === 0) {
        // set empty values for the edit form
        this.edit_rebate = Object.assign({}, {
          company_id: this.company.id,
          referred_company_id: this.company.id,
          amount_per_payrolled_worker: '',
          referral_start_date: null,
          referral_end_date: null,

          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        })
      }
      // if there is an existing rebate then set the edit form to these values
      else {
        this.edit_rebate = Object.assign({}, this.referral_rebate.rebate[0])
      }
      // show the edit form
      this.e_set_up_rebate = true
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_rebate = {}
      this.e_set_up_rebate = false
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editSetUpRebateForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editSetUpRebateForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);
          axios.post(this.crmApiPath + 'company/referral_rebate', this.edit_rebate).then(() => {
            this.$bus.$emit('company_referral::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // close form
            this.$nextTick(() => {
              this.e_set_up_rebate = false;
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            })
          });
        }
      });
    },
    /* -----------------------------------------------------------------------------------------------
     * edit information on template
     * -----------------------------------------------------------------------------------------------
     */
    /**
     * Return formatted datepicker selected date
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Set edit form rebate start date as formatted selected date
     * @param date
     */
    select_rebate_start_date(date) {
      if (date !== null) {
        this.edit_rebate.referral_start_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    /**
     * Set edit form rebate start date as formatted selected date
     * @param date
     */
    select_rebate_end_date(date) {
      if (date !== null) {
        this.edit_rebate.referral_end_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },

  }
}
</script>

<style scoped lang="scss">

.referrals {
  margin-bottom: 15px;
  background:    #ececec;
  padding:       7.5px;

  .referral_text {
    display:        inline-block;
    width:          calc(100% - 124px);
    vertical-align: middle;
  }

  .referral_cost {
    display:        inline-block;
    width:          120px;
    text-align:     center;
    background:     lighten($bc_5, 10%);
    vertical-align: middle;
    padding-bottom: 5px;
  }
}
</style>
